export const ORDINAL_3D_BACKGROUND_CAPTURE_TIMEOUT_MS = 45_000

const MAX_CONCURRENT_BACKGROUND_CAPTURES = 1

let activeBackgroundCaptures = 0
const attemptedBackgroundCaptureKeys = new Set<string>()
const slotListeners = new Set<() => void>()

type ShouldStartArgs = {
    autoCapturePreview: boolean
    hasPreview: boolean
    forceLive: boolean
    userActivated: boolean
    backgroundCaptureActive: boolean
}

export function shouldStartOrdinal3DBackgroundCapture({
    autoCapturePreview,
    hasPreview,
    forceLive,
    userActivated,
    backgroundCaptureActive,
}: ShouldStartArgs): boolean {
    return (
        autoCapturePreview &&
        !hasPreview &&
        !forceLive &&
        !userActivated &&
        !backgroundCaptureActive
    )
}

export function reserveOrdinal3DBackgroundCapture(key: string): (() => void) | null {
    if (!key) return null
    if (attemptedBackgroundCaptureKeys.has(key)) return null
    if (activeBackgroundCaptures >= MAX_CONCURRENT_BACKGROUND_CAPTURES) return null

    activeBackgroundCaptures += 1
    attemptedBackgroundCaptureKeys.add(key)

    let released = false
    return () => {
        if (released) return
        released = true
        activeBackgroundCaptures = Math.max(0, activeBackgroundCaptures - 1)
        globalThis.setTimeout(() => {
            slotListeners.forEach(listener => listener())
        }, 0)
    }
}

export function subscribeOrdinal3DBackgroundCaptureSlot(listener: () => void): () => void {
    slotListeners.add(listener)
    return () => {
        slotListeners.delete(listener)
    }
}

export function resetOrdinal3DBackgroundCaptureStateForTests() {
    activeBackgroundCaptures = 0
    attemptedBackgroundCaptureKeys.clear()
    slotListeners.clear()
}
